import React, { useState, useEffect } from 'react';
import FileUpload from './FileUpload';
import FileList from './FileList';
import './DocumentManager.css';

const DocumentManager = ({ entityType, entityId, canUpload = true, canDelete = true }) => {
  const [documents, setDocuments] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    fetchDocuments();
  }, [entityType, entityId]);

  const fetchDocuments = async () => {
    try {
      setLoading(true);
      setError('');
      const token = sessionStorage.getItem('token');
      const response = await fetch(
        `http://localhost:8080/api/v1/${entityType.toLowerCase()}s/${entityId}/documents`,
        {
          headers: {
            'Authorization': `Bearer ${token}`
          }
        }
      );

      if (!response.ok) {
        throw new Error('Failed to fetch documents');
      }

      const data = await response.json();
      setDocuments(data.data || []);
    } catch (err) {
      console.error('Error fetching documents:', err);
      setError('Failed to load documents');
    } finally {
      setLoading(false);
    }
  };

  const handleUploadSuccess = (newDocument) => {
    setDocuments(prev => [newDocument, ...prev]);
  };

  const handleUploadError = (errorMessage) => {
    setError(errorMessage);
  };

  const handleDelete = (documentId) => {
    setDocuments(prev => prev.filter(doc => doc.id !== documentId));
  };

  return (
    <div className="document-manager">
      <div className="document-manager-header">
        <h3>Documents</h3>
        <span className="document-count">{documents.length} file{documents.length !== 1 ? 's' : ''}</span>
      </div>

      {canUpload && (
        <FileUpload
          entityType={entityType}
          entityId={entityId}
          onUploadSuccess={handleUploadSuccess}
          onUploadError={handleUploadError}
          multiple={true}
        />
      )}

      {error && (
        <div className="document-manager-error">
          <span className="error-icon">⚠️</span>
          {error}
        </div>
      )}

      {loading ? (
        <div className="document-manager-loading">
          <div className="loading-spinner"></div>
          <div>Loading documents...</div>
        </div>
      ) : (
        <FileList
          documents={documents}
          entityType={entityType}
          entityId={entityId}
          onDelete={handleDelete}
          canDelete={canDelete}
        />
      )}
    </div>
  );
};

export default DocumentManager;

